import { Chip, Tooltip } from "@mui/material";

import { type ShiftChipData } from "./types";

interface ShipChipProps {
  shiftChipData: ShiftChipData;
}

export function ShiftChipTag(props: ShipChipProps) {
  const { shiftChipData } = props;
  const {
    type,
    label,
    color,
    getTooltip,
    additionalData,
    handleClick,
    customStyles = {},
  } = shiftChipData;

  return (
    <Tooltip title={getTooltip(additionalData)}>
      <Chip
        color={color}
        aria-label={`${type} Shift Chip Tag`}
        sx={{
          borderRadius: 2,
          fontWeight: "bold",
          ...customStyles,
        }}
        label={label}
        onClick={handleClick}
      />
    </Tooltip>
  );
}
